// Frontend twin of Helpers/ComplianceCalculator.cs — the scoring rules are duplicated
// there and must stay identical (change one, change both). They also mirror the Excel
// Summary sheet's COUNTIF convention so UI, PDF, and Excel never disagree:
//   - Applicable  = enabled strategies whose Complies is 1 (Yes), 2 (No) or 3 (Sometimes);
//                   null/anything else is "Not Applicable" and excluded
//   - Compliant   = Complies === 1 only ("Sometimes" scores 0%, per July 22 2026 team decision)
//   - Percent     = Compliant / Applicable, null when nothing is applicable
// Banding per July 7 2026 team decision: Green >80%, Yellow 50-80%, Red <50%.

export const BAND = {
    NONE: 'none',
    RED: 'red',
    YELLOW: 'yellow',
    GREEN: 'green'
};

// Green is Bootstrap $success (the PC brand has no green); yellow/red are PC brand tokens.
export const BAND_COLORS = {
    [BAND.GREEN]: '#198754',
    [BAND.YELLOW]: '#FDB415',
    [BAND.RED]: '#D21437'
};

// White text is readable on green/red; PC Black on yellow.
export const BAND_TEXT_COLORS = {
    [BAND.GREEN]: '#FFFFFF',
    [BAND.YELLOW]: '#2C2A29',
    [BAND.RED]: '#FFFFFF'
};

export function toBand(percent) {
    if (percent === null || percent === undefined) return BAND.NONE;
    if (percent > 80) return BAND.GREEN;
    if (percent >= 50) return BAND.YELLOW;
    return BAND.RED;
}

export function computeCompliance(strategies) {
    const stats = {
        applicable: 0,
        compliant: 0,
        prereqApplicable: 0,
        prereqCompliant: 0,
        agreedApplicable: 0,
        agreedCompliant: 0,
        p1Count: 0,
        p2Count: 0
    };

    (strategies || []).filter(s => s.Enabled).forEach(s => {
        const applicable = s.Complies === 1 || s.Complies === 2 || s.Complies === 3;
        const compliant = s.Complies === 1;

        if (applicable) {
            stats.applicable++;
            if (compliant) stats.compliant++;
            if (s.IsPrerequisite) {
                stats.prereqApplicable++;
                if (compliant) stats.prereqCompliant++;
            }
            if (s.AgreedUpon) {
                stats.agreedApplicable++;
                if (compliant) stats.agreedCompliant++;
            }
        }

        if (s.Priority === 1) stats.p1Count++;
        if (s.Priority === 2) stats.p2Count++;
    });

    stats.percent = stats.applicable === 0 ? null : (stats.compliant / stats.applicable) * 100;
    stats.prereqPercent = stats.prereqApplicable === 0 ? null : (stats.prereqCompliant / stats.prereqApplicable) * 100;
    stats.agreedPercent = stats.agreedApplicable === 0 ? null : (stats.agreedCompliant / stats.agreedApplicable) * 100;
    stats.band = toBand(stats.percent);
    stats.prereqBand = toBand(stats.prereqPercent);
    return stats;
}
